<template>
  <section class="hero" aria-labelledby="hero-title">
    <div class="hero-inner">
      <div class="hero-content">
        <p class="hero-subtitle">
          Accompagniamo le società sportive nel definire percorsi di preparazione atletica sicuri, <br class="p-break"> basati sulla scienza e adattati al contesto reale.
        </p>
        <a class="cta-primary" href="#consulenza" @click.prevent="scrollToCTA">Inizia ora il percorso <span aria-hidden="true">→</span></a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroHome',
  methods: {
    scrollToCTA() {
      const target = document.getElementById('consulenza')
      if (!target) return
      const header = document.querySelector('.site-header')
      const top = target.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0)
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.hero {
  position: relative;
  background-color: $primary;
  color: $white;
  overflow: hidden;
}

.hero-inner {
  position: relative;
  width: 100%;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
}

.hero-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 29px;
}

.p-break {
  display: none;
}

@media (min-width: 395px) {
  .p-break {
    display: block;
  }
}

@media (min-width: 448px) {
  .p-break {
    display: none;
  }
}

@media (min-width: 681px) {
  .p-break {
    display: block;
  }
}

.hero-subtitle {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 500;
  line-height: 1.7;
  text-align: center;
}

.cta-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  background-color: $primary;
  color: $white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 39px;
  border: 1px solid $white;
  white-space: nowrap;
}

.cta-primary:hover {
  background-color: $primary-light;
  color: $black;
}

.cta-primary:focus-visible {
  outline: 2px solid $white;
  outline-offset: 3px;
}

@media (min-width: 768px) {
  .hero-inner {
    padding: 64px 40px;
  }
}

@media (min-width: 900px) and (orientation: landscape) {
  .hero-inner {
    padding: 80px 120px;
  }
}
</style>
